import { flattenCategories } from "app/functions";
import * as types from "../../constants/action-types";

let initialState = {
    Translations: {},
    IconTypes: {},
    MainMenu: {},
    FooterLinks: false,
    citiesArr: [],
    ContentUrl: false,
    AppStoreLink: false,
    categoriesArr: false,
    BenefitTypes: false,
    DefaultGeo: false,
    PopTrans: {},
    Policy_url: false,
    Privacy_url: false,
    contentWorldsArr: false,
    BannerInterval: 0,
    LoginReturn: false,
    FirstLoginReturn: false,
    WorkPlaces: false,
    UserData: false,
    IsMarketingApproved: false,
    HotSearches: false,
    BannersArr: false,
    ClosedBenefitTypes: false,
    VerificationCodeMaxAttempsError: false,
    LockDownErr: false,
    SubCategoryMenu: false,
    MainCategoryMenu: false,
    Cart: false,
    cartRequest: false,
    UserComment: '',
    OrderIsDone: false,
    OrderStatusArr: false,
    SortArr: false,
    Survey: false,
    FirstLoginPopup: false,
    TaxPercent: false,
    TradeBenefitsChargeTypes: false,
    benefitTypesWhatRequireUserValidation: false,
    homePageBannersInterval: false,
    homePageSliderTypes: false,
    tradeBenefitType: false,
    carLeadServerError: "",
    vehicleAdDisplayTypes: false,
    megaMenuMaxCategories: false,
    megaMenuMaxSubCategories: false,
    navigationStripOffsetTop: 0,
    insuranceData: false,
    dataSharingConfig: false,
    Parameters: {},
    SearchIsNetwork: '',
    isFirstRegistrationNeeded: false,
    newsletterPopup: {},
    homepageLogos: {},
};

export default function constants_reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_TAX_PERCENT:
            return {
                ...state,
                TaxPercent: action.payload,
            };
        case types.SET_SURVEY:
            return {
                ...state,
                Survey: action.payload,
            };
        case types.SHOW_FIRST_LOGIN_POPUP:
            return {
                ...state,
                FirstLoginPopup: action.payload
            };
        case types.SET_SORT_ARR:
            return {
                ...state,
                SortArr: action.payload,
            };
        case types.ORDER_STATUS_ARR:
            return {
                ...state,
                OrderStatusArr: action.payload,
            };
        case types.UPDATE_USER_COMMENT:
            return {
                ...state,
                UserComment: action.payload,
            };
        case types.SET_ORDER_DONE:
            return {
                ...state,
                OrderIsDone: action.payload,
            };
        case types.SET_IS_MARKETING_APPROVED:
            return {
                ...state,
                isMarketingApproved: action.payload,    //possible to put marketing approved into user data
            };
        case types.SET_CART_REQUEST:
            return {
                ...state,
                cartRequest: action.payload,
            };
        case types.SET_CART:
            return {
                ...state,
                Cart: action.payload,
            };
        case types.UPDATE_CART_ITEMS:
            return {
                ...state,
                Cart: action.payload,
            };
        case types.SET_MAIN_CATEGORIES_MENU:
            return {
                ...state,
                MainCategoryMenu: action.payload
            };
        case types.SET_SUB_CATEGORIES_MENU:
            return {
                ...state,
                SubCategoryMenu: action.payload
            };
        case types.SET_LOCKDOWN_ERR:
            return {
                ...state,
                LockDownErr: action.payload.id === state.VerificationCodeMaxAttempsError ? action.payload : false
            };
        case types.SET_VERIFICATION_CODE_MAX_ATTAMPS_ERROR:
            return {
                ...state,
                VerificationCodeMaxAttempsError: action.payload,
            };
        case types.SET_BENEFIT_TYPES_FOR_LOGGED_USERS:
            return {
                ...state,
                ClosedBenefitTypes: action.payload
            };
        case types.SET_BANNERS_ARR:
            return {
                ...state,
                BannersArr: action.payload
            };

        case types.SET_HOMEPAGE_LOGOS:
            return {
                ...state,
                HomepageLogos: action.payload
            };
        case types.ADD_FAVORITE:
            let newFavoritesArr = state.UserData.favoritesArr.slice(0);
            if (newFavoritesArr.indexOf(action.payload.benefitId?.toString()) === -1) {
                newFavoritesArr.push(action.payload.benefitId.toString());
            }
            return {
                ...state,
                UserData: {
                    ...state.UserData,
                    favoritesArr: newFavoritesArr
                },
            };
        case types.REMOVE_FAVORITE:
            let newFavoritesArr2 = state.UserData.favoritesArr.filter((val) => {
                return val !== action.payload.benefitId?.toString();
            });

            return {
                ...state,
                UserData: {
                    ...state.UserData,
                    favoritesArr: newFavoritesArr2
                },
            };
        case types.SET_HOT_SEARCHES:
            return {
                ...state,
                HotSearches: action.payload
            };
        case types.SET_USER_DATA:
            return {
                ...state,
                UserData: action.payload
            };
        case types.SET_DISCOUNT_DEBIT_BANNER:
            return {
                ...state,
                Discount_Debit_Banner: action.payload,
            }
        case types.SET_SEARCH_IS_NETWORK:
            return {
                ...state,
                SearchIsNetwork: action.payload,
            }
        case types.SET_WORK_PLACES:
            return {
                ...state,
                WorkPlaces: action.payload
            };
        case types.SET_FIRST_LOGIN_RETURN:
            return {
                ...state,
                FirstLoginReturn: action.payload
            };
        case types.SET_LOGIN_RETURN:
            return {
                ...state,
                LoginReturn: action.payload
            };
        case types.SET_BANNER_INTERVAL:
            return {
                ...state,
                BannerInterval: action.payload
            };
        case types.SET_CONTENT_WORLDS:
            return {
                ...state,
                contentWorldsArr: action.payload
            };
        case types.SET_BENEFIT_TYPES:
            return {
                ...state,
                BenefitTypes: action.payload
            };
        case types.SET_CATEGORIES_ARR:
            return {
                ...state,
                categoriesArr: action.payload,
                categoriesMap: flattenCategories(action?.payload?.Data || [])
            };
        case types.SET_APP_STORE_LINK:
            return {
                ...state,
                AppStoreLink: action.payload
            };
        case types.SET_TRANSLATIONS:
            return {
                ...state,
                Translations: action.payload
            };
        case types.SET_ICON_TYPES:
            return {
                ...state,
                IconTypes: action.payload
            };
        case types.SET_MAIN_MENU:
            return {
                ...state,
                MainMenu: action.payload
            };
        case types.SET_FOOTER_LINKS:
            return {
                ...state,
                FooterLinks: action.payload
            };
        case types.SET_CITIES_ARR:
            return {
                ...state,
                citiesArr: action.payload
            };
        case types.SET_CONTENT_URL:
            return {
                ...state,
                ContentUrl: action.payload
            };
        case types.SET_DEFAULT_GEO:
            return {
                ...state,
                DefaultGeo: action.payload
            };
        case types.SET_POPUPS_TRANSLATIONS:
            return {
                ...state,
                PopTrans: action.payload
            };
        case types.SET_POLICY_URL:
            return {
                ...state,
                Policy_url: action.payload
            };
        case types.SET_PRIVACY_URL:
            return {
                ...state,
                Privacy_url: action.payload
            };
        case types.SET_TRADE_BENEFIT_CHARGE_TYPES:
            return {
                ...state,
                TradeBenefitsChargeTypes: action.payload
            };
        case types.SET_TYPES_WHAT_REQUIRE_USER_VALIDATION:
            return {
                ...state,
                benefitTypesWhatRequireUserValidation: action.payload
            };
        case types.SET_HOME_PAGE_BANNERS_INTERVAL:
            return {
                ...state,
                homePageBannersInterval: action.payload
            };
        case types.SET_HOME_PAGE_SLIDER_TYPES:
            return {
                ...state,
                homePageSliderTypes: action.payload
            };
        case types.SET_TRADE_BENEFIT_TYPE:
            return {
                ...state,
                tradeBenefitType: action.payload
            };
        case types.SET_VEHICLE_AD_DISPLAY_TYPES:
            return {
                ...state,
                vehicleAdDisplayTypes: action.payload
            };
        case types.SET_CAR_LEAD_SERVER_ERROR:
            return {
                ...state,
                carLeadServerError: action.payload
            };
        case types.SET_MAX_CATEGORIES:
            return {
                ...state,
                megaMenuMaxCategories: action.payload
            };
        case types.SET_MAX_SUB_CATEGORIES:
            return {
                ...state,
                megaMenuMaxSubCategories: action.payload
            };
        case types.SET_NEWSLETTER_POPUP:
            return {
                ...state,
                newsletterPopup: action.payload
            };
        case types.SET_MEGA_MENU:
            return {
                ...state,
                megaMenu: action.payload
            };
        case types.SET_INSURANCE_DATA:
            return {
                ...state,
                insuranceData: action.payload,
            };
        case types.UPDATE_USER_DATA:
            return {
                ...state,
                UserData: {
                    ...state.UserData,
                    ...action.payload,
                },
            };
        case types.SET_USER_WAIVER_AGREEMENTS:
            return {
                ...state,
                UserData: {
                    ...state.UserData,
                    legalWaiversAgreements: action.payload,
                },
            };
        case types.SET_DATA_SHARING_CONFIG:
            return {
                ...state,
                dataSharingConfig: action.payload,
            };

        case types.SET_CONSENTS_CONFIG:
            return {
                ...state,
                consentsConfig: action.payload,
            };


        case types.SET_PARAMETER:
            return {
                ...state,
                Parameters: {
                    ...state.Parameters,
                    ...action.payload
                },
            };
        default:
            return state;
    }
}
